export const en = {
    'image-download-error': 'Error downloading image. Try again later.',
    'request-error': 'An unexpected error occurred.'
};
